import React from 'react';
import {
  BrowserRouter as Router, Route, Routes,
} from 'react-router-dom';
import { Navigate } from 'react-router';
import { Provider } from 'jotai/index';
import store from './atoms';
import Widget from './pages/Widget';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>

          <Route path="/" element={<Widget />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

      </Router>
    </Provider>
  );
}

export default App;
